import { render, staticRenderFns } from "./alert-table-item.vue?vue&type=template&id=5e41ea1f&scoped=true"
import script from "./alert-table-item.vue?vue&type=script&lang=js"
export * from "./alert-table-item.vue?vue&type=script&lang=js"
import style0 from "./alert-table-item.vue?vue&type=style&index=0&id=5e41ea1f&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e41ea1f",
  null
  
)

export default component.exports